<template>
  <div>
    <van-swipe ref="swipe" :autoplay="3000" :show-indicators="false" class="swipe_box">
      <van-swipe-item v-for="(item, index) in rightList" :key="item.img" class="swipe_item" @click="item.func">
        <img class="img" :src="item.img">

        <div class="icon_box" @click.stop="closeImg(index)">
          <van-icon name="close" class="close_icon" />
        </div>
      </van-swipe-item>
    </van-swipe>
  </div>
</template>
<script>
import {
  Swipe,
  SwipeItem
} from "vant";
export default {
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
  },
  props: {
    rightList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    closeImg(i) {
      this.$emit('closeImg', i)
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/variables.less";

.swipe_box {
  transform: translateX(10px);
}

.swipe_item {
  position: relative;
  width: 76px;

  .img {
    width: 93%;
    height: 93%;
  }

  .icon_box {
    position: absolute;
    right: 0;
    top: 0;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .close_icon {
      color: @textcolor1;
      font-size: 14px;
    }
  }
}
</style>